
export const environment = {
  production: false,
  name: "QA",

  auth0: {
    domain: 'transnetyx-qa.us.auth0.com',
    clientId: 'pbgq8O29dZRf1WwK30QO0JPbQzWdzuzH',
    audience: 'Ops_SnpViewer_API',
    scope: '',
    redirectUri: `https://snpviewer-qa.transnetyx.com`
  },

  apiUrl: "https://apionprem-qa.transnetyx.com/snpviewer/"
};
